/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Comenzar a utilizar Svelte es superfácil gracias al comando:`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-cli"
      }}><code parentName="pre" {...{
          "className": "language-cli"
        }}>{`npx degit sveltejs/template mi-nueva-aplicacion`}</code></pre></div>
    <p>{`Su instalación y configuración es de las más rápidas además de que te permite agregar con comandos adiciónales TypeScript u otras tecnologías fácilmente.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;